// extracted by mini-css-extract-plugin
module.exports = {"productsCollection":"AmarrupaProduct_productsCollection__6hc8g","productCollection":"AmarrupaProduct_productCollection__0ZMoB"};